/**
 * มอนวิ่งแข่งชิงโชค (ผู้ใช้เลือก 9 ต.ค. 2026) — ตัวเผาเหรียญแบบมีส่วนร่วมของทั้งเมือง
 *
 * แบบพาริมิวชวล: เงินเดิมพันทุกคนรวมกองเดียว ระบบหัก `cut` (เผาทิ้ง) ที่เหลือแบ่งให้คนที่แทงตัวชนะตามสัดส่วนที่แทง
 * ไม่มีใครแทงตัวชนะ = เผาทั้งกอง · **โกลด์เท่านั้น ห้ามเพชร** (ไม่ใช่การพนันด้วยเงินจริง ตามนโยบาย Play Store)
 * ค่าตั้งอยู่ที่ data/balance.json (`derby`) · server ตัดสิน/สุ่ม (server/src/derby-hub.ts) · ไฟล์นี้ pure
 */
import balanceJson from "./data/balance.json" with { type: "json" };
export const DERBY = balanceJson.derby;
export const DERBY_TEXT = {
    closed: "ปิดรับแทงแล้ว รอรอบถัดไป",
    runner: "ไม่มีตัววิ่งตัวนี้",
    min: `แทงขั้นต่ำ ${DERBY.minBet} โกลด์`,
    max: "เกินเพดานแทงต่อรอบของเลเวลคุณ",
    gold: "โกลด์ไม่พอ",
};
/** เพดานแทงรวมต่อรอบ */
export function derbyMaxBet(baseLevel) {
    return DERBY.maxBetPerLv * Math.max(1, baseLevel);
}
/** ตรวจคำสั่งแทง (server ใช้ตัดสิน client ใช้แสดงก่อนกด) */
export function derbyBetDenial(o) {
    if (!o.open)
        return "closed";
    if (!Number.isInteger(o.runner) || o.runner < 0 || o.runner >= o.runners)
        return "runner";
    if (!Number.isFinite(o.amount) || o.amount < DERBY.minBet)
        return "min";
    if (o.already + o.amount > derbyMaxBet(o.baseLevel))
        return "max";
    if (o.gold < o.amount)
        return "gold";
    return null;
}
/** อัตราจ่ายโดยประมาณต่อ 1 โกลด์ ถ้าตัวนี้ชนะ (กองรวม × (1−cut) ÷ กองของตัวนั้น) · 0 = ยังไม่มีใครแทง */
export function derbyOdds(pools, runner) {
    const total = pools.reduce((a, b) => a + b, 0);
    const mine = pools[runner] ?? 0;
    return mine > 0 ? (total * (1 - DERBY.cut)) / mine : 0;
}
/** แบ่งเงินรางวัล: คืน map key → โกลด์ที่ได้ (ปัดลง เศษเผาทิ้ง) */
export function derbyPayouts(bets, winner) {
    const total = bets.reduce((a, b) => a + b.amount, 0);
    const onWinner = bets.filter((b) => b.runner === winner).reduce((a, b) => a + b.amount, 0);
    const out = new Map();
    if (onWinner <= 0)
        return out;
    const prize = total * (1 - DERBY.cut);
    for (const b of bets) {
        if (b.runner !== winner)
            continue;
        out.set(b.key, (out.get(b.key) ?? 0) + Math.floor((prize * b.amount) / onWinner));
    }
    return out;
}
/**
 * ตำแหน่ง 0–1 ของตัววิ่งที่เวลา t (0–1 ของช่วงวิ่ง) — ใช้วาดแอนิเมชันฝั่ง client
 * เส้นโค้งมาจาก seed (server สุ่ม) และเข้าเส้นชัยตามลำดับ `finish` (วินาทีจาก server) จึงตรงกับผลจริงเสมอ
 */
export function derbyProgress(seed, runner, finish, longest, t) {
    const at = t * longest;
    if (at >= finish)
        return 1;
    const x = at / finish;
    // ส่ายขึ้นลงเล็กน้อยแต่ไม่ถอยหลัง: x + wobble ที่เป็นศูนย์ที่ปลายทั้งสอง
    const ph = ((seed * 9301 + runner * 49297) % 233280) / 233280 * Math.PI * 2;
    return Math.min(1, Math.max(0, x + 0.06 * Math.sin(ph + x * Math.PI * 3) * Math.sin(x * Math.PI)));
}
//# sourceMappingURL=derby.js.map